import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import ProfileDetails from "../components/profileComponents/ProfileDetails";
import Form from "../components/profileComponents/Form";
import classes from "./MyProfile.module.scss";
import LoadingDots from "../components/UI/LoadingDots";
import KeysContainer from "../components/servicesComponents/KeysContainer";
import ApiKey from "../components/servicesComponents/ApiKey";
import { E2Data } from "../lib/ddd/ddd";
import { useQuery } from "@tanstack/react-query";
import { ClientTypes, OrgIdContext } from "../store/orgId_context";
import { Helmet } from "react-helmet";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const e2Data = new E2Data("Countries");
e2Data.format="Full";
e2Data.filter = "EinvoicesOrder <> null";
e2Data.orderBy = "EinvoicesOrder asc, CountryNameOriginal asc";
e2Data.take = null;

const e2DataCurrency = new E2Data("common/Currencies");
e2DataCurrency.format="Full";
e2DataCurrency.take = 1000;

const e2SCR = new E2Data("EU_SCR");
e2SCR.format="Full";
//e2DataCurrency.filter = "EinvoicesOrder <> null";
//e2DataCurrency.orderBy = "EinvoicesOrder asc, CountryNameOriginal asc";
//e2DataCurrency.take = null;

const e2EntityInfo = new E2Data("EU_AOrg");
e2EntityInfo.format="Full";

const e2OrgData = new E2Data("EU_AOrg");

const MyProfile = () => {
  const {connectionKey, clientType, sessionInfo, ISVCustomer,isIntegrator} = useContext(OrgIdContext);
  const [profileData, setProfileData] = useState(null);
  const [isLoaded, setIsLoaded] = useState(null);
  const [isEditMode, setIsEditMode] = useState(true);
  const [countriesList, setCountriesList] = useState([]);
  const [currenciesList, setCurrenciesList] = useState([]);
  const [scrList, setScrList] = useState([]);
  const [entityInfo, setEntityInfo] = useState(null);
  
  const {isPending : isOrgPending, data : orgData, refetch} = useQuery({
    queryKey: ['Data.GetEntityData', e2OrgData.GetParamsObject()],
    queryFn: () => e2OrgData.GetData(),
  })

  const {isPending : isDataPending, data : countriesData} = useQuery({
    queryKey: ['Data.GetEntityData', e2Data.GetParamsObject()],
    queryFn: () => e2Data.GetData(),
    staleTime: Infinity
  })

  const {isPending : isInfoPending, data : entityInfoData} = useQuery({
    queryKey: ['Data.GetEntityInfo', e2EntityInfo.GetParamsObject()],
    queryFn: () => e2EntityInfo.GetEntityInfo(),
    staleTime: Infinity
  })

  const {isPending : isCurrencyDataPending, data : currencyData} = useQuery({
    queryKey: ['Data.GetEntityData', e2DataCurrency.GetParamsObject()],
    queryFn: () => e2DataCurrency.GetData(),
    staleTime: Infinity
  })

  const {isPending : isSCRPending, data : scrData} = useQuery({
    queryKey: ['Data.GetEntityData', e2SCR.GetParamsObject()],
    queryFn: () => e2SCR.GetData(),
    staleTime: Infinity
  })


  useEffect(() => {
    if(!isOrgPending){
      let data = {};
      data.org = orgData.result?.data[0];
      setProfileData(data);
      setIsLoaded(true);
    }

    if(!isDataPending)
      setCountriesList(countriesData.result?.data);
    

    if(!isCurrencyDataPending)
      setCurrenciesList(currencyData?.result?.data || []);

    if(!isSCRPending)
      setScrList(scrData?.result?.data || []);


    if(!isInfoPending)
      setEntityInfo(entityInfoData?.result);

  }, [isDataPending, isOrgPending, isCurrencyDataPending, isInfoPending, isSCRPending])
  // console.log(companyData);

  /* useEffect(() => {
    setProfileData(null);
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.GetTransformerData",
            args: {
              type: "profile",
            },
          },
          id: 20,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.result && res.data.result.Result) {
          console.log(res.data.result.Result);
          setProfileData(res.data.result.Result);
          setIsLoaded(true);
          axios
            .post(
              apiRequestAddress,
              {
                jsonrpc: "2.0",
                method: "Data.GetEntityData",
                params: {
                  entity: "Countries",
                  filter: "EinvoicesOrder <> null",
                  orderBy: "EinvoicesOrder asc, CountryNameOriginal asc",
                  format: "Full",
                  "@nulls": false,
                },
                id: 35,
              },
              {
                withCredentials: true,
              }
            )
            .then((res) => {
              setCountriesList(res.data.result.data);
            });
        }
      });
  }, []); */

  const onEditModeHandler = (isInMode) => {
    setIsEditMode(isInMode);
    if (isInMode) {
    }
  };
  return (<>
    <Helmet>
      <title>Profile | DDD Invoices</title>
    </Helmet>
    <div className={`h-100 w-100 p-5 ${classes.container}`}>
      {!isLoaded && (
        <LoadingDots className="w-100 h-100 d-flex align-items-center justify-content-center" />
      )}
      {isLoaded && profileData && (
        <>
          {/* {connectionKey && (ISVCustomer || clientType===ClientTypes.ISV || isIntegrator  ) && 
          <ApiKey/>
          } */}
          {/*<KeysContainer></KeysContainer>*/}
          <ProfileDetails
            // orgTitle={companyData.Organization.Title || "default"}
            orgTitle={profileData.org.Name || "default"}
            onEditModeHandler={onEditModeHandler}
            isEditMode={true}
          />
          <Form
            profileData={profileData}
            isEditMode={isEditMode}
            onEditModeHandler={onEditModeHandler}
            countriesList={countriesList}
            currenciesList={currenciesList}
            scrList={scrList}
            entityInfo={entityInfo}
            refetch={refetch}
          />
        </>
      )}
    </div>
  </>);
};

export default MyProfile;
